import {
  IconSquare0,
  IconBuildingSkyscraper,
  IconPackages,
  IconTruckDelivery,
  IconUser,
  IconCalendar,
} from "@tabler/icons-react";

const OrderInfo = ({ data }) => {
  return (
    <>
      <div className="grid grid-cols-3 gap-4">
        <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
          <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
            <IconSquare0 />
          </div>
          <div>
            <p className="text-font-color-100">გზავნილის ნომერი</p>
            <h5 className="text-[20px]/[24px] font-medium">
              {data?.trackingNumber}
            </h5>
          </div>
        </div>
        <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
          <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
            <IconBuildingSkyscraper />
          </div>
          <div className="text-font-color-100">ქალაქი</div>
          <h5 className="text-[20px]/[24px] font-medium">{data?.city}</h5>
        </div>
        <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
          <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
            <IconPackages />
          </div>
          <div className="text-font-color-100">რაოდენობა</div>
          <h5 className="text-[20px]/[24px] font-medium">{data?.quantity}</h5>
        </div>
        <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
          <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
            <IconTruckDelivery />
          </div>
          <div className="text-font-color-100">სტატუსი</div>
          <h5 className="text-[20px]/[24px] font-medium">
            {data?.orderStatus}
          </h5>
        </div>
        {data?.orderStatus == "ჩაბარდა" && (
          <>
            {" "}
            <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
              <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
                <IconUser />
              </div>
              <div className="text-font-color-100">მიმღები</div>
              <h5 className="text-[20px]/[24px] font-medium">
                {data?.signerName}
              </h5>
            </div>
            <div className="card bg-card-color rounded-xl md:p-6 p-4 flex md:gap-4 gap-2 items-center border border-dashed border-border-color">
              <div className="sm:w-[56px] sm:h-[56px] sm:min-w-[56px] w-[40px] h-[40px] min-w-[40px] text-secondary bg-primary-10 rounded-full flex items-center justify-center">
                <IconCalendar />
              </div>
              <div className="text-font-color-100">ჩაბარების თარიღი</div>
              <h5 className="text-[20px]/[24px] font-medium">
                {data?.deliveryDateTime?.substring(
                  0,
                  data?.deliveryDateTime?.lastIndexOf(":")
                )}
              </h5>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default OrderInfo;
